module.exports = __webpack_public_path__ + "assets/webgl/wp_painted_concrete_color.67e82d8d.jpg";